import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
  imports: [
    CommonModule,
    NgxMaskDirective,
  ],
  providers:[provideNgxMask()]
})
export class PortalDoVendedorUtilsPortalVendedorApiModule {}
